// @generated by protoc-gen-es v2.2.2 with parameter "target=ts"
// @generated from file v1/crypto.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/crypto.proto.
 */
export const file_v1_crypto: GenFile = /*@__PURE__*/
  fileDesc("Cg92MS9jcnlwdG8ucHJvdG8SAnYxIkIKDVNpZ25lZE1lc3NhZ2USDQoFa2V5aWQYASABKAkSDwoHcGF5bG9hZBgCIAEoDBIRCglzaWduYXR1cmUYAyABKAwiIwoQRW5jcnlwdGVkTWVzc2FnZRIPCgdwYXlsb2FkGAEgASgMIjcKCVB1YmxpY0tleRINCgVrZXlpZBgBIAEoCRIbCgdlZDI1NTE5GAIgASgJUgplZDI1NTE5cHViIjkKClByaXZhdGVLZXkSDQoFa2V5aWQYASABKAkSHAoHZWQyNTUxORgCIAEoCVILZWQyNTUxOXByaXZCLFoqZ2l0aHViLmNvbS9nYXJldGhnZW9yZ2UvYmFja3Jlc3QvZ2VuL2dvL3YxYgZwcm90bzM");

/**
 * @generated from message v1.SignedMessage
 */
export type SignedMessage = Message<"v1.SignedMessage"> & {
  /**
   * a unique identifier generated as the SHA256 of the public key used to sign the message.
   *
   * @generated from field: string keyid = 1;
   */
  keyid: string;

  /**
   * the payload
   *
   * @generated from field: bytes payload = 2;
   */
  payload: Uint8Array;

  /**
   * the signature of the payload
   *
   * @generated from field: bytes signature = 3;
   */
  signature: Uint8Array;
};

/**
 * Describes the message v1.SignedMessage.
 * Use `create(SignedMessageSchema)` to create a new message.
 */
export const SignedMessageSchema: GenMessage<SignedMessage> = /*@__PURE__*/
  messageDesc(file_v1_crypto, 0);

/**
 * @generated from message v1.EncryptedMessage
 */
export type EncryptedMessage = Message<"v1.EncryptedMessage"> & {
  /**
   * @generated from field: bytes payload = 1;
   */
  payload: Uint8Array;
};

/**
 * Describes the message v1.EncryptedMessage.
 * Use `create(EncryptedMessageSchema)` to create a new message.
 */
export const EncryptedMessageSchema: GenMessage<EncryptedMessage> = /*@__PURE__*/
  messageDesc(file_v1_crypto, 1);

/**
 * @generated from message v1.PublicKey
 */
export type PublicKey = Message<"v1.PublicKey"> & {
  /**
   * a unique identifier generated as the SHA256 of the public key.
   *
   * @generated from field: string keyid = 1;
   */
  keyid: string;

  /**
   * base64 encoded public key
   *
   * @generated from field: string ed25519 = 2 [json_name = "ed25519pub"];
   */
  ed25519: string;
};

/**
 * Describes the message v1.PublicKey.
 * Use `create(PublicKeySchema)` to create a new message.
 */
export const PublicKeySchema: GenMessage<PublicKey> = /*@__PURE__*/
  messageDesc(file_v1_crypto, 2);

/**
 * @generated from message v1.PrivateKey
 */
export type PrivateKey = Message<"v1.PrivateKey"> & {
  /**
   * a unique identifier generated as the SHA256 of the public key.
   *
   * @generated from field: string keyid = 1;
   */
  keyid: string;

  /**
   * base64 encoded private key
   *
   * @generated from field: string ed25519 = 2 [json_name = "ed25519priv"];
   */
  ed25519: string;
};

/**
 * Describes the message v1.PrivateKey.
 * Use `create(PrivateKeySchema)` to create a new message.
 */
export const PrivateKeySchema: GenMessage<PrivateKey> = /*@__PURE__*/
  messageDesc(file_v1_crypto, 3);

